import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { title } from 'process';
import { PaymentsPage } from 'src/app/model/page/group/api-docs/payments-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-payments-page',
  templateUrl: './payments-page.component.html',
  styleUrls: ['./payments-page.component.scss']
})
export class PaymentsPageComponent implements OnInit {
  paymentsPage: PaymentsPage = {} as PaymentsPage;

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'payments') {
        this.paymentsPage.htmlTitle = title.htmlTitle;
      }
    });
    this.paymentsPage.sections = [];
    this.paymentsPage.ribbonTileSections = [];
    this.paymentsPage.creditCardPaymentSections = [];
    this.paymentsPage.ndcPaymentsSections = [];

    const query = { 'fields.title': 'Payments' };
    this.contentfulService.getPageContentResponse(query).then((PaymentsPageEntries) => {
      this.mapBanner(PaymentsPageEntries.includes.Entry);
      this.mapPageInfo(PaymentsPageEntries.items);
      this.sharedDataService.addSharedData(this.paymentsPage.banner);
      this.mapSections(PaymentsPageEntries.includes.Entry);
    });
  }

  private mapBanner(paymentsPageEntries: Entry<any>[]) {
    paymentsPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let image: any = entry.fields['image'] as string;
    let video: any = entry.fields['video'] as string;
    this.paymentsPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: image.fields.file.url,
      video: video?.fields?.file?.url
    };
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.paymentsPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.paymentsPage.banner.url = entry.fields?.url;
      this.paymentsPage.banner.editorEmail = editorDetails?.pop();
      this.paymentsPage.banner.editorShortName = editorDetails?.pop();
      this.paymentsPage.banner.editorFullName = editorDetails?.pop();
      this.paymentsPage.htmlTitle = entry.fields.htmlTitle;
    });
  }

  private mapSections(paymentsPageEntries: Entry<any>[]) {
    paymentsPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        switch (entry.fields['group']) {
          case 'NDC-Payments':
            this.mapNdcPaymentsSections(entry);
            break;
          case 'Credit-Card-Payment-Authentication':
            this.mapCreditCardPaymentsAuthenticationSections(entry);
            break;
          case 'ribbon-tile':
            this.mapEntryToRibbonTileSection(entry);
            break;
          default:
            console.error('New group Found - ' + entry.fields['title']);
            break;
        }
      });
    this.paymentsPage.sections.sort((a, b) => a.order - b.order);
  }

  private mapNdcPaymentsSections(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#').pop();

    this.paymentsPage.ndcPaymentsSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }

  private mapCreditCardPaymentsAuthenticationSections(entry: Entry<any>) {
    let givenTitle: any = entry.fields['title'] as string;
    let pageTitle = givenTitle.split('#').pop();

    this.paymentsPage.creditCardPaymentSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }

  private mapEntryToSection(entry: Entry<any>) {
    let title: any = entry.fields['title'] as string;
    this.paymentsPage.sections.push({
      title: title.split('#').pop(),
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
    this.paymentsPage.sections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToRibbonTileSection(entry: Entry<any>) {
    let tBody: string[] = [];
    let pageBody: any = entry.fields['body'] as string;
    pageBody.split('@').forEach((apiArrow: any) => {
      if (apiArrow !== '') {
        tBody.push(apiArrow);
      }
    });
    this.paymentsPage.ribbonTileSections.push({
      title: entry.fields['title'] as string,
      body: '',
      bodyArrows: tBody,
      order: entry.fields['order'] as number,
      group: entry.fields['group'] as string
    });
    // console.log('ribbon', this.paymentsPage.ribbonTileSections);
  }
}
